<template>
  <v-card class="px-3 pb-3">
    <v-row class="d-flex justify-space-between">
      <v-card-title class="headline" primary-title>{{
        popPupTitle
      }}</v-card-title>
      <v-spacer />
      <div class="pa-2"><v-btn icon color="pink" @click="$emit('close-dialog')">
        <v-icon>mdi-close</v-icon>
      </v-btn></div>
      
    </v-row>
    <v-divider></v-divider>
    <dr-layout-placeholder
      ref="drLayoutPlaceHolder"
      :model="{ $ID: 'popup' + this.$route.name, Name: 'PopPup' }"
      @close-dialog="$emit('close-dialog')"
    ></dr-layout-placeholder>
  </v-card>
</template>

<script>
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'

export default {
  name: 'PopPupLayout',
  mixins: [inputMixin],
  created() {
    let popPupId = this.$store.state.appRunner.currentPopPupPageId
    let page = this.$store.getters.getAllPages.find(x => x.$ID === popPupId)
    if (!!page && !!page.MakeOverlayTransparent) {
      document.documentElement.classList.add('pop-up-layout-custom-styles')
    }
    document.documentElement.classList.add('pop-up-layout-is-open')
  },
  beforeDestroy() {
    document.documentElement.classList.remove('pop-up-layout-custom-styles')
    document.documentElement.classList.remove('pop-up-layout-is-open')
  },
  computed: {
    popPupTitle() {
      const popPupId = this.$store.state.appRunner.currentPopPupPageId
      const page = this.$store.getters.getAllPages.find(x => x.$ID === popPupId)
      return this.evaluateExpression(page.PopPupTitle)
    }
  }
}
</script>

<style>
.pop-up-layout-is-open {
  overflow: hidden;
}
.pop-up-layout-custom-styles .dr-page .v-overlay .v-overlay__scrim {
  opacity: 0 !important;
}

.pop-up-layout-custom-styles .v-dialog {
  margin: 0px;
  box-shadow: unset;
}
</style>